import { Button, Grid } from '@material-ui/core';
import { useStyles } from './parametros-list-styles';
import { ParametrosListData } from './parametros-list-data';
import { NovoIcon } from 'views/components/icons';
import { ParametroSistemaModel } from 'model/api/gestao/parametro-sistema/parametro-sistema-model';
import { AccordionSaurus } from 'views/components/accordions/accordion-saurus/accordion-saurus';
import { useCallback, useEffect, useState } from 'react';
import { useGetParametroSistemas } from 'data/api/gestao/parametro-sistema';
import { Paginacao } from 'views/components/paginacao';
import { useCadastros, useToastSaurus } from 'services/app';
import { DialogParametro } from 'views/components/dialog/dialog-parametro/dialog-parametro';

interface ParametrosListProps {
  sistemaId: string;
}

export const ParametrosList = ({ sistemaId }: ParametrosListProps) => {

  const { showToast } = useToastSaurus()
  const classes = useStyles();

  const { abrirCadastroParametro, cadastroParametroState } = useCadastros()

  const { getParametroSistemas, carregando } = useGetParametroSistemas()

  const [queryStatus, setQueryStatus] = useState({
    page: 1,
    totalPages: 0,
    totalResults: 0,
    list: Array<ParametroSistemaModel>(),
  });
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [selectedModel, setSelectedModel] = useState<ParametroSistemaModel>(new ParametroSistemaModel())

  const fillResult = useCallback(
    (
      page: number,
      totalPages: number,
      totalResults: number,
      list: Array<ParametroSistemaModel>
    ) => {
      setQueryStatus({
        page: page,
        list: list,
        totalResults: totalResults,
        totalPages: totalPages,
      });
    },
    []
  );

  const search = useCallback(
    async (newPage: number) => {
      try {
        const res = await getParametroSistemas(sistemaId, newPage, ``);
        if (res.erro) throw res.erro;

        if (!res.resultado) {
          return;
        }

        //se o index for maior que as paginas ele busca a ultima
        if (
          res.resultado?.data?.pageIndex > res.resultado?.data?.totalPages &&
          res.resultado?.data?.totalResults > 0
        ) {
          await search(res.resultado?.data?.totalPages);
          return;
        }

        fillResult(
          res.resultado?.data?.pageIndex,
          res.resultado?.data?.totalPages,
          res.resultado?.data?.totalResults,
          res.resultado?.data?.list
        );

        return res;
      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [getParametroSistemas, sistemaId, fillResult, showToast]
  );

  const pageChanged = useCallback(
    async (newPage: number) => {
      if (newPage <= queryStatus.totalPages || newPage > 0) {
        await search(newPage);
      }
    },
    [search, queryStatus.totalPages]
  );

  useEffect(() => {
    if (!cadastroParametroState.aberto && !openDialog)
      search(queryStatus.page)
  }, [queryStatus.page, search, cadastroParametroState.aberto, openDialog])

  const onClick = useCallback((model: ParametroSistemaModel) => {
    setSelectedModel(model)
    setOpenDialog(true)
  }, [])

  return (
    <>
      <AccordionSaurus
        labelPrimary='Parâmetros'
      >
        <div className={classes.defaultContainer}>
          <Grid container>
            <Grid item xs={12} className={classes.listContainer}>
              <Grid style={{
                padding: '0 16px'
              }}>
                <Paginacao
                  pageChanged={pageChanged}
                  totalPages={queryStatus.totalPages}
                  totalRegisters={queryStatus.totalResults}
                  currentPage={queryStatus.page}
                />
              </Grid>
              <ParametrosListData
                atualizarList={() => search(queryStatus.page)}
                carregando={carregando}
                list={queryStatus.list}
                selectedList={[]}
                onCardSelected={onClick}
                onCardChecked={() => { }}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent='flex-end'>
                <Grid item md={6} lg={5} xs={12} style={{ padding: '0 8px 16px' }}>
                  <Button
                    variant="contained"
                    color='primary'
                    fullWidth
                    onClick={() => abrirCadastroParametro(sistemaId, '', false)}
                    size="large"
                  >
                    <NovoIcon tipo="BUTTON_PRIMARY" />
                    NOVO PARÂMETRO
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </AccordionSaurus>
      <DialogParametro
        openned={openDialog}
        model={selectedModel}
        closeDialog={() => setOpenDialog(false)}
        sistemaId={sistemaId}
      />
    </>
  );
};
